const MobileHybridDev = {
  title: 'Mobile Development (iOS & Android)',
  subtitle: '',
  technologies: [
    'JavaScript',
    'TypeScript',
    'React Native',
    'Redux',
    'Jest TDD',
  ],
  list: [
    {
      title: 'Cross-platform software',
      desc: 'development of native mobile applications for both Android & iOS devices.',
    },
    {
      title: 'High performance',
      desc: 'high application performance and user-friendly interface',
    },
  ],
}

const MobileSwiftDev = {
  title: 'iOS Development (iOS / iPadOS / MacOS / WatchOS)',
  subtitle: '',
  technologies: ['Swift UI', 'UIKit', 'Redux'],
  list: [
    {
      title: 'Cross-platform',
      desc: 'development of applications compatible with all Apple devices (iOS / iPadOS / MacOS / WatchOS)',
    },
  ],
}

const FrontEndDev = {
  title: 'Front End Development',
  subtitle:
    'Specialized in Front End Development, building complex user interfaces with high level UX for both web and mobile.',
  technologies: [
    'JavaScript',
    'TypeScript',
    'HTML5',
    'CSS3',
    'SCSS',
    'React',
    'Gatsby',
    'Redux',
    'Jest TDD',
  ],
  list: [
    {
      title: 'JavaScript Development',
      desc: 'architecting and building web/mobile applications with JavaScript/TypeScript, React, Gatsby.',
    },
    {
      title: 'Responsive Design',
      desc: 'adapting and optimizing web pages to work on all screen sizes (mobile, tablet & desktop).',
    },
    {
      title: 'Internationalizaton (i18n)',

      desc: 'experienced in developing multilingual and bidirectional web application.',
    },
  ],
}

const BackEndDev = {
  title: 'Back End Development',
  subtitle: '',
  technologies: ['JavaScript', 'TypeScript', 'Node JS', 'Firebase'],
  list: [
    {
      title: 'REST API',
      desc: 'design and development of RESTful API servers using Express framework.',
    },
  ],
}

export const SkillsList: Array<SkillType> = [
  MobileHybridDev,
  MobileSwiftDev,
  FrontEndDev,
  BackEndDev,
]

export interface ListItemType {
  title: string
  desc: string
}
export interface SkillType {
  title: string
  subtitle: string
  technologies: Array<string>
  list: Array<ListItemType>
}

export const OtherTechnologies = ['Git', 'GitHub', 'NPM']
